import CancelIcon from 'mdi-react/CancelIcon'
import CheckIcon from 'mdi-react/CheckIcon'
import TruckCheckIcon from 'mdi-react/TruckCheckIcon'
import { useDispatch, useSelector } from 'react-redux'

import Button from '@/components/form/Button'
import { Translation } from '@/components/i18n/Translation'
import {
  cancelDeviceOrder,
  completeDeviceOrder,
  deliverDeviceOrder,
  getDeviceOrder,
  getIsPostPending,
  sendDeviceOrderToEcom,
} from '@/ducks/deviceOrderReducer'
import useBetaAccess from '@/hooks/beta-access'
import { useIsDustin, useIsMobit } from '@/hooks/user'
import { DEVICE_ORDER_STATUS } from '@/util/orders'

import './device-order-options.scss'

const DeviceOrderOptions = () => {
  const { status } = useSelector(getDeviceOrder)

  return (
    [
      DEVICE_ORDER_STATUS.AT_VENDOR,
      DEVICE_ORDER_STATUS.PROCESSED,
      DEVICE_ORDER_STATUS.SENT_TO_ECOM,
    ].includes(status) && (
      <div className="order-options">
        {/* @ts-ignore */}
        <CompleteOrder />

        {/* @ts-ignore */}
        <DeliverOrder />

        {/* @ts-ignore */}
        <SendOrderToEcom />

        {/* @ts-ignore */}

        <CancelOrder />
      </div>
    )
  )
}

export default DeviceOrderOptions

const CancelOrder = () => {
  const dispatch = useDispatch()

  const { status, id } = useSelector(getDeviceOrder)
  const isPostPending = useSelector(getIsPostPending)

  return (
    [DEVICE_ORDER_STATUS.AT_VENDOR, DEVICE_ORDER_STATUS.PROCESSED].includes(status) && (
      <div className="order-options__option">
        <Button
          Icon={CancelIcon}
          disabled={isPostPending}
          // @ts-ignore

          onClick={() => dispatch(cancelDeviceOrder(id))}
        >
          <Translation id="Cancel Order" />
        </Button>
      </div>
    )
  )
}

const CompleteOrder = () => {
  const dispatch = useDispatch()

  const { status, estimated_delivery, id } = useSelector(getDeviceOrder)
  const isPostPending = useSelector(getIsPostPending)

  return (
    DEVICE_ORDER_STATUS.AT_VENDOR === status && (
      <div className="order-options__option">
        <Button
          Icon={CheckIcon}
          disabled={isPostPending || !estimated_delivery}
          // @ts-ignore
          onClick={() => dispatch(completeDeviceOrder(id))}
        >
          <Translation id="Order Processed" />
        </Button>
      </div>
    )
  )
}

const DeliverOrder = () => {
  const dispatch = useDispatch()

  const { status, delivery_date, id } = useSelector(getDeviceOrder)
  const isPostPending = useSelector(getIsPostPending)

  return (
    [DEVICE_ORDER_STATUS.PROCESSED].includes(status) && (
      <div className="order-options__option">
        <Button
          Icon={TruckCheckIcon}
          disabled={isPostPending || !delivery_date}
          // @ts-ignore
          onClick={() => dispatch(deliverDeviceOrder(id))}
        >
          <Translation id="Order Delivered" />
        </Button>
      </div>
    )
  )
}

const SendOrderToEcom = () => {
  const dispatch = useDispatch()

  const { hasDeviceOrderToEcom } = useBetaAccess()
  const isMobit = useIsMobit()
  const isDustin = useIsDustin()

  const { status, id } = useSelector(getDeviceOrder)
  const isPostPending = useSelector(getIsPostPending)

  const getTextId = () => {
    if (isMobit) return 'Send to Multicase'
    if (isDustin) return 'Send to Dustin'

    return 'Send to Ecom'
  }

  return (
    [DEVICE_ORDER_STATUS.AT_VENDOR, DEVICE_ORDER_STATUS.PROCESSED].includes(status) &&
    hasDeviceOrderToEcom && (
      <div className="order-options__option">
        <Button
          Icon={TruckCheckIcon}
          disabled={isPostPending}
          // @ts-ignore
          onClick={() => dispatch(sendDeviceOrderToEcom(id))}
        >
          <Translation id={getTextId()} />
        </Button>
      </div>
    )
  )
}
